import React from 'react';
import './Popup.css';
import { FaTimes, FaLinkedin, FaInstagram, FaGithub} from 'react-icons/fa';

// Import the profile picture for the popup
import profilePic from '../assets/team/prem_face.jpg';

const Popup = ({ onClose }) => {
  return (
    // The class names here (e.g., popup-overlay-new) match the new CSS
    <div className="popup-overlay-new">
      <div className="popup-container-new">
        <button className="close-button-new" onClick={onClose}>
          <FaTimes />
        </button>
        
        <div className="popup-header-new">
          <h2 className="popup-title-new">PCE ACM Webmaster</h2>
        </div>

        <div className="popup-content-new">
          <div className="ambassador-card-new">
            <img src={profilePic} alt="Prem Rahangdale" className="ambassador-photo-new" />
            <div className="ambassador-info-new">
              <h3 className="ambassador-name-new">Prem Rahangdale</h3>
              <p className="ambassador-role-new">Webmaster</p>
            </div>
          </div>
          <div className="rewards-icons-new">
            {/* The icons are now wrapped in anchor tags to make them clickable */}
            <a href="https://www.instagram.com/prem789k/" target="_blank" rel="noopener noreferrer" className="reward-icon-new">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/in/prem-rahangdale-1b5375246/" target="_blank" rel="noopener noreferrer" className="reward-icon-new">
              <FaLinkedin />
            </a>
            <a href="https://github.com/prem789k-coder" target="_blank" rel="noopener noreferrer" className="reward-icon-new">
              <FaGithub />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
